import url from './urls'

const state = {
  isLoading: false,
  newsList: null,
  newsDetail: null
}

const mutations = {
  GETLIST (state) {
    state.isLoading = true

    fetch(url.news.list)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.newsList = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETDETAIL (state, id) {
    state.isLoading = true

    fetch(url.news.detail + id)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.newsDetail = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  getList ({ commit }) {
    commit('GETLIST')
  },

  getDetail ({ commit }, id) {
    commit('GETDETAIL', id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
